/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Row,
  Col,
  Card,
  Typography,
  message,
  Space,
  Empty,
  Divider,
  Popconfirm,
  Button,
  Modal,
  List,
} from "antd";
import {
  FilterOutlined,
  ScanOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { useParams, useLocation } from "react-router-dom";
import {
  lazy,
  Suspense,
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { useAuth } from "../../../../AuthContext";
import GETDetalleOrden from "../../../../helpers/ordenes/GETDetalleOrden";
import HeaderBack from "../../../../components/layout/headers/HeaderBack";
import { accionConfig } from "../../../../utils/getAccionConfig";
import AppLayout from "../../../../components/layout/AppLayout";
import Loader from "../../../../components/loader/Loader";
import PUTIniciarOrden from "../../../../helpers/ordenes/PUTIniciarOrden";
import PUTPausarOrden from "../../../../helpers/ordenes/PUTPausarOrden";
import PUTConfirmarOmaUbiPalet from "../../../../helpers/ordenes/PUTConfirmarOmaUbiPalet";
import PUTConfirmarOmaUbi from "../../../../helpers/ordenes/PUTConfirmarOmaUbi";
import PUTCompletarOma from "../../../../helpers/ordenes/PUTCompletarOma";
import GETCodigoBarra from "../../../../helpers/auditoria/GETCodigoBarra";
import { useNavigate } from "react-router-dom";
import PaletCard from "../render/PaletCard";
import ArticuloCard from "../render/ArticuloCard";
import { formatEtiquetaUbicacion } from "../../../../utils/formatEtiquetaUbicacion";
import ModalLoteVtoVLX from "../../modalLoteVLX/ModalLoteVLX";
import { useAppVersionContext } from "../../../../AppVersionContext";

const usaLote = process.env.REACT_APP_USALOTE;

// Modal de teclado alfanumérico
const ModalTecladoAlfanumerico = lazy(
  () =>
    import("../../../../components/modalTecladoAlfanumerico/ModalTecladoAlfanumerico"),
);

// Modal de cantidad
const ModalTecladoCantidad = lazy(
  () =>
    import("../../../../components/modalTecladoCantidad/ModalTecladoCantidad"),
);

// Modal para palets
const ModalLongPressPalet = lazy(
  () => import("../modalLongPressPalet/ModalLongPressPalet"),
);

const { Text } = Typography;

const DetalleOrden = ({ darkMode, setDarkMode }) => {
  const { idomam } = useParams();
  const location = useLocation();
  const { tiposma } = location.state || {};
  const { usaModoLote } = useAppVersionContext();

  const navigate = useNavigate();
  const { loggedUser } = useAuth();

  const [orden, setOrden] = useState(null);
  const [loading, setLoading] = useState(true);
  const [procesandoAccion, setProcesandoAccion] = useState(false);
  const [tecladoVisible, setTecladoVisible] = useState(false);
  const [valorTecladoGlobal, setValorTecladoGlobal] = useState(null);
  const [tipoTecladoGlobal, setTipoTecladoGlobal] = useState(null);

  const [modalLoteVtoVLX, setModalLoteVtoVLX] = useState({
    open: false,
    items: [],
    ubicacionActual: null,
    sku: null,
  });

  const [paletActivoVLX, setPaletActivoVLX] = useState(null);

  const [filtroSkuVLX, setFiltroSkuVLX] = useState(null);

  // Estados para UI
  const [currentUbi, setCurrentUbi] = useState(
    "No ha escaneado ninguna ubicación.",
  );

  // 🔧 CAMBIO 1: Inicializar desde sessionStorage
  const [idUbicacionSeleccionada, setIdUbicacionSeleccionada] = useState(() => {
    return sessionStorage.getItem(`orden_${idomam}_ubicacion`) || null;
  });

  const [highlightedRowKey, setHighlightedRowKey] = useState(null);
  const [modalVisible, setModalVisible] = useState({
    status: false,
    payload: {},
  });
  const [modalLongPressVisible, setModalLongPressVisible] = useState({
    status: false,
    payload: {},
  });

  const renderActivoRef = useRef(null);
  const valorTipeadoRef = useRef("");
  const procesandoRef = useRef(false);

  //  Helper para guardar en sessionStorage
  const guardarUbicacionEnStorage = useCallback(
    (ubiId) => {
      const clave = `orden_${idomam}_ubicacion`;

      if (ubiId && idomam) {
        sessionStorage.setItem(clave, ubiId);
      }
    },
    [idomam],
  );

  const itemsFiltrados = useMemo(() => {
    const itemsOrden = orden?.ubicacionesEmpleadoLogeado || [];

    if (!filtroSkuVLX) {
      return itemsOrden;
    }

    return itemsOrden.filter(
      (item) =>
        item?.articulologico_sku?.toLowerCase() === filtroSkuVLX.toLowerCase(),
    );
  }, [orden?.ubicacionesEmpleadoLogeado, filtroSkuVLX]);

  // === Handlers ===

  const manejarConfirmacionTeclado = (valor) => {
    const tipo = renderActivoRef.current;

    // Ignoramos la validación de tipo
    setValorTecladoGlobal(valor);

    if (tipo) {
      setTipoTecladoGlobal(tipo);
    }

    setTimeout(() => {
      setValorTecladoGlobal(null);
      setTipoTecladoGlobal(null);
    }, 0);

    setTecladoVisible(false);
    renderActivoRef.current = null;
  };

  const handleAccion = async () => {
    if (procesandoAccion) return;
    if (!orden || !loggedUser) return;
    const accion = accionConfig[orden.estadoOpe];
    if (!accion) return;

    setProcesandoAccion(true);
    try {
      const response =
        orden.estadoOpe === "1"
          ? await PUTIniciarOrden(orden.idOpe)
          : await PUTPausarOrden(orden.idOpe, accion.accion);

      if (response?.status === 200) {
        const nuevoEstado = accion.accion ? "4" : "2";
        setOrden((prev) => ({ ...prev, estadoOpe: nuevoEstado }));
        // message.success(response.data?.descri || "Estado actualizado.");
      } else {
        message.error(
          response?.data?.message ||
            "No se pudo cambiar el estado de la orden.",
        );
      }
    } catch {
      message.error("Error al procesar la acción.");
    } finally {
      setProcesandoAccion(false);
    }
  };

  const handleVolverCantidadACero = async (palet) => {
    if (!loggedUser || !orden) return;

    const payloadREU = {
      idomaope: orden.idOpe,
      idpalet: palet.palet_id,
      idubid: palet.ubicacion_id,
      cantidad: 0,
    };

    try {
      const response = await PUTConfirmarOmaUbiPalet(payloadREU);
      if (response?.status === 200) {
        const resOrdenActualizada = await GETDetalleOrden(orden.id);
        if (resOrdenActualizada?.status === 200) {
          setOrden((prev) => {
            const nuevaUbicacion =
              resOrdenActualizada.data?.idUbicacionSeleccionada ??
              prev?.idUbicacionSeleccionada;

            // 🔧 CAMBIO 3: Guardar en storage
            if (nuevaUbicacion) {
              guardarUbicacionEnStorage(nuevaUbicacion);
            }

            return {
              ...resOrdenActualizada.data,
              idUbicacionSeleccionada: nuevaUbicacion,
            };
          });
        }
      } else {
        message.error(
          response?.data?.message || "Ocurrió un error al confirmar",
        );
      }
    } catch (error) {
      message.error("Error de conexión al confirmar la acción.");
    }
  };

  const handleConfirmModal = async (itemActualizado) => {
    if (!loggedUser || !orden) return;

    const {
      valorFinal,
      sku,
      ubicacion,
      articulologico_ctdpar,
      articuloparte_numeroparte,
    } = itemActualizado;

    const codigo =
      articulologico_ctdpar > 1 ? `${sku}${articuloparte_numeroparte}` : sku;

    let idartp = itemActualizado.idartp;

    if (!idartp) {
      const response =
        usaModoLote === "true"
          ? await GETCodigoBarra(codigo, null, true, false)
          : await GETCodigoBarra(codigo);

      idartp = response?.data?.idartp;
    }

    if (!idartp) {
      message.error("Artículo no encontrado.");
      return;
    }

    const payloadOma = {
      idomamov: orden.idOpe,
      idartp,
      idubid: ubicacion,
      cantidad: valorFinal,
      esLecturaCodBarras: false,
    };

    const res = await PUTConfirmarOmaUbi(payloadOma);

    if (res?.status === 200) {
      const resOrdenActualizada = await GETDetalleOrden(orden.id);

      if (resOrdenActualizada?.status === 200) {
        setOrden((prev) => {
          const nuevaUbicacion =
            resOrdenActualizada.data?.idUbicacionSeleccionada ??
            prev?.idUbicacionSeleccionada ??
            ubicacion;

          if (nuevaUbicacion) {
            guardarUbicacionEnStorage(nuevaUbicacion);
          }

          return {
            ...resOrdenActualizada.data,
            idUbicacionSeleccionada: nuevaUbicacion,
          };
        });

        const cardId =
          itemActualizado.articulologico_ctdpar > 1
            ? `art-${itemActualizado.sku}-${itemActualizado.articuloparte_numeroparte}-${itemActualizado.ubicacion}`
            : `art-${itemActualizado.sku}-${itemActualizado.ubicacion}`;

        setHighlightedRowKey(cardId);
        setTimeout(() => setHighlightedRowKey(null), 1500);

        setTimeout(() => {
          const el = document.getElementById(cardId);
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }, 50);

        setModalVisible({ status: false, payload: {} });
      }
    } else {
      message.error(res?.data?.message || "Error al actualizar el artículo.");
    }
  };

  const confirmarPaletActivoEnUbicacionVLX = async (ubicacionDestino) => {
    if (!paletActivoVLX || !ubicacionDestino || !orden) return;

    const payloadREU = {
      idomaope: orden.idOpe,
      idpalet: paletActivoVLX.idpale,
      idubid: ubicacionDestino.ubicacion_id,
      cantidad: 1,
    };

    const res = await PUTConfirmarOmaUbiPalet(payloadREU);

    if (res?.status !== 200) {
      message.error(res?.data?.message || "Error al confirmar el palet.");
      return;
    }

    const resOrden = await GETDetalleOrden(orden.id);

    if (resOrden?.status === 200) {
      setOrden((prev) => ({
        ...resOrden.data,
        idUbicacionSeleccionada:
          resOrden.data?.idUbicacionSeleccionada ??
          prev?.idUbicacionSeleccionada ??
          ubicacionDestino.ubicacion_id,
      }));

      setCurrentUbi(ubicacionDestino.ubicacion_codigo?.toUpperCase());
      setIdUbicacionSeleccionada(ubicacionDestino.ubicacion_id);
      guardarUbicacionEnStorage(ubicacionDestino.ubicacion_id);
    }

    setPaletActivoVLX(null);
    // message.success("Palet confirmado en ubicación destino.");
  };

  const handleProcesamientoVLX = async (codigoLimpio) => {
    const existsUbi = orden.ubicacionesEmpleadoLogeado?.find(
      (x) => x?.ubicacion_codigo?.toLowerCase() === codigoLimpio.toLowerCase(),
    );

    if (existsUbi && !paletActivoVLX) {
      const ubiId = existsUbi.ubicacion_id;

      setCurrentUbi(existsUbi.ubicacion_codigo.toUpperCase());
      setIdUbicacionSeleccionada(ubiId);
      guardarUbicacionEnStorage(ubiId);

      setOrden((prev) => ({
        ...prev,
        idUbicacionSeleccionada: ubiId,
      }));

      return;
    }

    const responseUbicacion = await GETCodigoBarra(codigoLimpio);

    // Ubicacion

    if (responseUbicacion?.status === 200 && responseUbicacion?.data?.idubid) {
      const ubicacionDestino = {
        ubicacion_id: responseUbicacion.data.idubid,
        ubicacion_codigo: codigoLimpio,
      };

      if (paletActivoVLX) {
        await confirmarPaletActivoEnUbicacionVLX(ubicacionDestino);
        return;
      }

      const ubiId = responseUbicacion.data.idubid;

      setCurrentUbi(codigoLimpio);
      setIdUbicacionSeleccionada(ubiId);
      guardarUbicacionEnStorage(ubiId);

      setOrden((prev) => ({
        ...prev,
        idUbicacionSeleccionada: ubiId,
      }));

      return;
    }

    // Palet

    if (responseUbicacion?.status === 200 && responseUbicacion?.data?.idpale) {
      const idpale = responseUbicacion.data.idpale;

      const itemPalet = orden.ubicacionesEmpleadoLogeado?.find(
        (item) => item?.palet_id === idpale,
      );

      if (!itemPalet) {
        message.warning("El palet leído no pertenece a esta orden.");
        return;
      }

      setPaletActivoVLX({
        idpale: itemPalet.palet_id,
        descripcion: itemPalet.palet_descripcion,
        ubicacionId: itemPalet.ubicacion_id,
        ubicacionCodigo: itemPalet.ubicacion_codigo,
      });

      const newRowKey = `palet-${itemPalet.palet_id}`;

      setHighlightedRowKey(newRowKey);

      setTimeout(() => {
        const el = document.getElementById(newRowKey);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 50);

      setTimeout(() => setHighlightedRowKey(null), 1500);

      return;
    }

    const ubicacionActual = orden.idUbicacionSeleccionada;

    if (!ubicacionActual) {
      message.error("Primero debe escanear una ubicación.");
      return;
    }

    const response = await GETCodigoBarra(codigoLimpio, null, false, false);

    if (response?.status !== 200) {
      message.error(response?.data?.message || "Código no válido");
      return;
    }

    const sku = response?.data?.articulologico_sku || codigoLimpio;

    let itemOrden = orden.ubicacionesEmpleadoLogeado?.find(
      (item) =>
        item?.articulologico_sku?.toLowerCase() === sku.toLowerCase() &&
        item?.ubicacion_id === ubicacionActual,
    );

    let idartpParaConfirmar = itemOrden?.idartp || response?.data?.idartp;

    if (response?.data?.idtipa === "04") {
      const itemsDelArticulo =
        orden.ubicacionesEmpleadoLogeado?.filter(
          (item) => item?.idartl === response.data.idartl,
        ) || [];

      const loteVtoDistintos = [
        ...new Set(
          itemsDelArticulo
            .map((item) => item?.valcar)
            .filter(
              (valcar) =>
                valcar !== null && valcar !== undefined && valcar !== "",
            ),
        ),
      ];

      if (loteVtoDistintos.length > 1) {
        setModalLoteVtoVLX({
          open: true,
          items: itemsDelArticulo,
          ubicacionActual,
          sku,
        });

        return;
      }

      if (loteVtoDistintos.length === 1 && itemsDelArticulo.length > 0) {
        itemOrden = itemsDelArticulo[0];
        idartpParaConfirmar = itemOrden.idartp;
      }
    }

    if (!idartpParaConfirmar || idartpParaConfirmar === "00000000") {
      message.warning("No se pudo determinar el artículo leído.");
      return;
    }

    const payloadOma = {
      idomamov: orden.idOpe,
      idartp: idartpParaConfirmar,
      idubid: ubicacionActual,
      cantidad: 1,
      esLecturaCodBarras: true,
    };

    const res = await PUTConfirmarOmaUbi(payloadOma);

    if (res?.status !== 200) {
      message.error(res?.data?.message || "Error al confirmar el artículo.");
      return;
    }

    const resOrden = await GETDetalleOrden(orden.id);

    if (resOrden?.status === 200) {
      itemOrden = resOrden.data.ubicacionesEmpleadoLogeado?.find(
        (item) =>
          item.idartp === idartpParaConfirmar &&
          item.ubicacion_id === ubicacionActual,
      );

      setOrden((prev) => {
        const nuevaUbicacion =
          resOrden.data?.idUbicacionSeleccionada ??
          prev?.idUbicacionSeleccionada ??
          ubicacionActual;

        if (nuevaUbicacion) {
          guardarUbicacionEnStorage(nuevaUbicacion);
        }

        return {
          ...resOrden.data,
          idUbicacionSeleccionada: nuevaUbicacion,
        };
      });
    }

    setFiltroSkuVLX(sku);

    if (itemOrden) {
      const newRowKey =
        itemOrden.articulologico_ctdpar > 1
          ? `art-${itemOrden.articulologico_sku}-${itemOrden.articuloparte_numeroparte}-${itemOrden.ubicacion_id}`
          : `art-${itemOrden.articulologico_sku}-${itemOrden.ubicacion_id}`;

      setHighlightedRowKey(newRowKey);

      setTimeout(() => {
        const el = document.getElementById(newRowKey);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 50);

      setTimeout(() => setHighlightedRowKey(null), 1500);
    }
  };

  const confirmarLoteVtoVLX = async (itemSeleccionado) => {
    const ubicacionActual = modalLoteVtoVLX.ubicacionActual;

    const payloadOma = {
      idomamov: orden.idOpe,
      idartp: itemSeleccionado.idartp,
      idubid: ubicacionActual,
      cantidad: 1,
      esLecturaCodBarras: true,
    };

    const res = await PUTConfirmarOmaUbi(payloadOma);

    if (res?.status !== 200) {
      message.error(res?.data?.message || "Error al confirmar el artículo.");
      return;
    }

    const resOrden = await GETDetalleOrden(orden.id);

    if (resOrden?.status === 200) {
      setOrden((prev) => ({
        ...resOrden.data,
        idUbicacionSeleccionada:
          resOrden.data?.idUbicacionSeleccionada ??
          prev?.idUbicacionSeleccionada ??
          ubicacionActual,
      }));
    }

    setFiltroSkuVLX(modalLoteVtoVLX.sku);

    setModalLoteVtoVLX({
      open: false,
      items: [],
      ubicacionActual: null,
      sku: null,
    });
  };

  const procesarCodigoEscaneado = async (codigo) => {
    const codigoLimpio = codigo?.trim()?.toUpperCase();
    if (!codigoLimpio || !orden || procesandoRef.current) return;

    procesandoRef.current = true;

    try {
      if (usaLote === "true") {
        // lógica VLX
        await handleProcesamientoVLX(codigoLimpio);
        return;
      }

      const existsUbi = orden.ubicacionesEmpleadoLogeado?.find(
        (x) =>
          x?.ubicacion_codigo?.toLowerCase() === codigoLimpio.toLowerCase(),
      );

      if (existsUbi) {
        const ubiId = existsUbi.ubicacion_id;
        setCurrentUbi(existsUbi.ubicacion_codigo.toUpperCase());
        setIdUbicacionSeleccionada(ubiId);

        guardarUbicacionEnStorage(ubiId);

        setOrden((prev) => ({
          ...prev,
          idUbicacionSeleccionada: ubiId,
        }));
        return;
      }

      const response = await GETCodigoBarra(codigoLimpio);
      if (response?.status !== 200) {
        message.error(response?.data?.message || "Código no válido");
        return;
      }

      const { idubid, idartp } = response.data || {};

      if (idubid) {
        // Es ubicación
        setCurrentUbi(codigoLimpio);
        setIdUbicacionSeleccionada(idubid);

        //  Guardar en storage la ubicación de trabajo
        guardarUbicacionEnStorage(idubid);

        setOrden((prev) => ({
          ...prev,
          idUbicacionSeleccionada: idubid,
        }));
      } else if (idartp) {
        // Es artículo
        const ubicacionActual = orden.idUbicacionSeleccionada;
        if (!ubicacionActual) {
          message.error("Primero debe escanear una ubicación.");
          return;
        }

        const payloadOma = {
          idomamov: orden.idOpe,
          idartp: idartp,
          idubid: ubicacionActual,
          cantidad: 1,
          esLecturaCodBarras: true,
        };

        const res = await PUTConfirmarOmaUbi(payloadOma);
        if (res?.status === 200) {
          const resOrden = await GETDetalleOrden(orden.id);
          if (resOrden?.status === 200) {
            setOrden((prev) => {
              const nuevaUbicacion =
                resOrden.data?.idUbicacionSeleccionada ??
                prev?.idUbicacionSeleccionada;

              // 🔧 CAMBIO 7: Guardar en storage
              if (nuevaUbicacion) {
                guardarUbicacionEnStorage(nuevaUbicacion);
              }

              return {
                ...resOrden.data,
                idUbicacionSeleccionada: nuevaUbicacion,
              };
            });

            const itemActualizado =
              resOrden.data.ubicacionesEmpleadoLogeado?.find(
                (item) =>
                  item.idartp === idartp &&
                  item.ubicacion_id === ubicacionActual,
              );

            if (itemActualizado) {
              const newRowKey =
                itemActualizado.articulologico_ctdpar > 1
                  ? `art-${itemActualizado.articulologico_sku}-${itemActualizado.articuloparte_numeroparte}-${itemActualizado.ubicacion_id}`
                  : `art-${itemActualizado.articulologico_sku}-${itemActualizado.ubicacion_id}`;

              setHighlightedRowKey(newRowKey);
              const el = document.getElementById(newRowKey);
              if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "center" });
              }
              setTimeout(() => setHighlightedRowKey(null), 1500);
            }
          }
        } else {
          message.error(
            res?.data?.message || "Error al confirmar el artículo.",
          );
        }
      }
    } catch (error) {
      console.error("Error al procesar código:", error);
      message.error("Error de conexión al validar el código.");
    } finally {
      procesandoRef.current = false;
    }
  };

  // === Efectos ===

  useEffect(() => {
    const fetchData = async () => {
      if (!idomam || !loggedUser) {
        setOrden(null);
        return;
      }
      try {
        setLoading(true);
        const response = await GETDetalleOrden(idomam);
        if (response?.status >= 200 && response.status < 300 && response.data) {
          let dataConUbi = response.data;

          // 🔧 CAMBIO 8: Priorizar: 1) Backend, 2) Storage, 3) null
          const ubiDesdeBackend = response.data.idUbicacionSeleccionada;
          const ubiDesdeStorage = sessionStorage.getItem(
            `orden_${idomam}_ubicacion`,
          );
          const ubiFinal = ubiDesdeBackend || ubiDesdeStorage;

          if (ubiFinal) {
            setIdUbicacionSeleccionada(ubiFinal);
            dataConUbi = {
              ...response.data,
              idUbicacionSeleccionada: ubiFinal,
            };
            const ubi = response.data.ubicacionesEmpleadoLogeado?.find(
              (u) => u.ubicacion_id === ubiFinal,
            );
            if (ubi) {
              setCurrentUbi(ubi.ubicacion_codigo.toUpperCase());
            }
          }

          setOrden(dataConUbi);
        } else {
          setOrden(null);
        }
      } catch {
        message.error("No se pudo cargar la información de la orden.");
        setOrden(null);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [idomam, loggedUser]);

  // Limpiar storage al desmontar
  useEffect(() => {
    return () => {
      if (idomam) {
        sessionStorage.removeItem(`orden_${idomam}_ubicacion`);
      }
    };
  }, [idomam]);

  // Teclado global (desde header/modal)
  useEffect(() => {
    if (valorTecladoGlobal !== null) {
      procesarCodigoEscaneado(valorTecladoGlobal.trim());
    }
  }, [valorTecladoGlobal]);

  // Teclado físico
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!orden || orden.estadoOpe !== "2") return;

      if (e.key === "Enter") {
        e.preventDefault();
        const codigo = valorTipeadoRef.current.trim();
        if (codigo) {
          procesarCodigoEscaneado(codigo);
          valorTipeadoRef.current = "";
        }
      } else if (e.key.length === 1 && !e.ctrlKey && !e.altKey && !e.metaKey) {
        valorTipeadoRef.current += e.key;
      } else if (e.key === "Backspace") {
        valorTipeadoRef.current = valorTipeadoRef.current.slice(0, -1);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [orden, paletActivoVLX]);

  const accionActual = orden ? accionConfig[orden.estadoOpe] || null : null;
  const ordenActiva = orden ? orden.estadoOpe === "2" : false;

  const headerComponent = (
    <HeaderBack
      modulo={"Mis Órdenes"}
      data={{ headerTitle: orden?.comprobanteOMA }}
      acciones={
        <div style={{ display: "flex", gap: 12 }}>
          {ordenActiva && (
            <span
              onClick={() => {
                setTecladoVisible(true);
              }}
              style={{ cursor: "pointer", display: "flex" }}
            >
              <ScanOutlined style={{ fontSize: "36px", color: "white" }} />
            </span>
          )}
          <span
            onClick={handleAccion}
            style={{
              cursor: procesandoAccion ? "default" : "pointer",
              display: "flex",
              pointerEvents: procesandoAccion ? "none" : "auto",
              opacity: procesandoAccion ? 0.6 : 1,
            }}
          >
            {procesandoAccion ? (
              <SyncOutlined spin style={{ fontSize: "36px", color: "white" }} />
            ) : (
              accionActual?.icon
            )}
          </span>
        </div>
      }
    />
  );

  return (
    <AppLayout
      darkMode={darkMode}
      setDarkMode={setDarkMode}
      header={headerComponent}
    >
      <div
        style={{
          height: "100%",
          padding: "8px",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        {loading && <Loader />}
        {!loading && orden && (
          <Row gutter={[8, 8]} justify="start" align="stretch">
            {/* Sticky header de ubicación */}

            <Col
              span={24}
              style={{
                position: "sticky",
                top: -10,
                zIndex: 10,
                padding: 0,
                backgroundColor: darkMode ? "#222" : "#fafafa",
                color: darkMode ? "#fff" : "#000",
                borderRadius: 10,
              }}
            >
              <div
                className="ubi-wrapper"
                style={{
                  cursor:
                    usaModoLote === "true" && filtroSkuVLX
                      ? "pointer"
                      : "default",
                  padding: "10px 14px",
                }}
                onClick={() => {
                  if (usaModoLote === "true" && filtroSkuVLX) {
                    setFiltroSkuVLX(null);
                  }
                }}
              >
                <Typography.Title
                  level={4}
                  className="ubi-text"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    margin: 0,
                    flexWrap: "wrap",
                    fontSize: 21,
                  }}
                >
                  {usaModoLote === "true" && filtroSkuVLX && (
                    <span
                      style={{
                        height: 30,
                        minWidth: 30,
                        padding: "0 10px",
                        borderRadius: 999,
                        background: darkMode ? "#313131" : "#ececec",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "all .2s ease",
                      }}
                    >
                      <FilterOutlined
                        style={{
                          color: "#43a047",
                          fontSize: 16,
                        }}
                      />
                    </span>
                  )}

                  <span
                    style={{
                      fontWeight: 600,
                      letterSpacing: 0.3,
                    }}
                  >
                    <span
                      style={{
                        fontWeight: 600,
                        letterSpacing: 0.3,
                      }}
                    >
                      {paletActivoVLX
                        ? "Esperando ubicación..."
                        : formatEtiquetaUbicacion(currentUbi)}
                    </span>
                  </span>
                </Typography.Title>
              </div>

              {usaModoLote === "true" && filtroSkuVLX && (
                <div
                  style={{
                    display: "flex",
                    textAlign: "center",
                    justifyContent: "center",
                  }}
                >
                  <h4>
                    Filtrando por artículo: <b>{filtroSkuVLX}</b>
                  </h4>
                </div>
              )}

              {usaModoLote === "true" && paletActivoVLX && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 8,
                    padding: "2px 8px 8px",
                    fontSize: 15,
                    color: darkMode ? "#f5f5f5" : "#333",
                  }}
                >
                  <span>
                    Transportando palet: <b>{paletActivoVLX.idpale}</b>
                  </span>

                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      setPaletActivoVLX(null);
                    }}
                    style={{
                      border: "none",
                      background: darkMode ? "#444" : "#e0e0e0",
                      color: darkMode ? "#fff" : "#333",
                      borderRadius: "50%",
                      width: 20,
                      height: 20,
                      cursor: "pointer",
                      lineHeight: "20px",
                      padding: 0,
                      fontSize: 15,
                      fontWeight: 700,
                    }}
                  >
                    ×
                  </button>
                </div>
              )}
            </Col>

            {/* Ítems */}
            {orden?.ubicacionesEmpleadoLogeado?.length === 0 ? (
              <Col span={24}>
                <Space
                  style={{
                    width: "100%",
                    justifyContent: "center",
                    marginTop: "5rem",
                  }}
                >
                  <Empty description="No hay elementos para mostrar." />
                </Space>
              </Col>
            ) : (
              orden?.ubicacionesEmpleadoLogeado?.map((item) => {
                const isPalet = item.palet_id != null;
                const key = isPalet
                  ? `palet-${item.palet_id}`
                  : item.articulologico_ctdpar > 1
                    ? `art-${item.articulologico_sku}-${item.articuloparte_numeroparte}-${item.ubicacion_id}`
                    : `art-${item.articulologico_sku}-${item.ubicacion_id}`;

                return (
                  <Col span={24} key={key} id={key} style={{ display: "flex" }}>
                    {isPalet ? (
                      <PaletCard
                        item={item}
                        darkMode={darkMode}
                        ordenActiva={ordenActiva}
                        onResetCantidad={handleVolverCantidadACero}
                        onOpenLongPress={(payload) => {
                          setModalLongPressVisible({ status: true, payload });
                        }}
                        currentUbi={currentUbi}
                        ubicacionResaltadaId={idUbicacionSeleccionada}
                        paletActivoVLX={paletActivoVLX}
                      />
                    ) : (
                      <ArticuloCard
                        item={item}
                        darkMode={darkMode}
                        ordenActiva={ordenActiva}
                        onOpenCantidadModal={(payload) =>
                          setModalVisible({ status: true, payload })
                        }
                        isHighlighted={
                          highlightedRowKey ===
                          (item.articulologico_ctdpar > 1
                            ? `art-${item.articulologico_sku}-${item.articuloparte_numeroparte}-${item.ubicacion_id}`
                            : `art-${item.articulologico_sku}-${item.ubicacion_id}`)
                        }
                        tiposma={tiposma}
                        ubicacionResaltadaId={idUbicacionSeleccionada}
                      />
                    )}
                  </Col>
                );
              })
            )}

            {/* Botón de completar */}
            {ordenActiva && orden?.ubicacionesEmpleadoLogeado?.length > 0 && (
              <>
                <Divider style={{ margin: 6 }} />
                <Col span={24}>
                  <Popconfirm
                    title="Confirmar acción"
                    onConfirm={async () => {
                      const res = await PUTCompletarOma(orden.idOpe);
                      if (res?.status === 200) {
                        // message.success(
                        //   res?.data?.descri || "Orden completada con éxito.",
                        // );
                        navigate(-1);
                      } else {
                        message.error(
                          res?.data?.message ||
                            "Ocurrió un error al completar la orden.",
                        );
                      }
                    }}
                    okText="Sí"
                    cancelText="No"
                  >
                    <Button type="primary" size="large" block>
                      Completar orden
                    </Button>
                  </Popconfirm>
                </Col>
              </>
            )}
          </Row>
        )}
        {!loading && !orden && (
          <Card
            style={{
              textAlign: "center",
              backgroundColor: darkMode ? "#1f1f1f" : "#fafafa",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "32px",
            }}
          >
            <Text type="secondary" style={{ fontSize: "19px" }}>
              Orden no encontrada.
            </Text>
          </Card>
        )}
      </div>

      {/* Modales */}
      {tecladoVisible && (
        <Suspense fallback={null}>
          <ModalTecladoAlfanumerico
            open={tecladoVisible}
            onClose={() => {
              setTecladoVisible(false);
            }}
            darkMode={darkMode}
            letras={["A", "B", "C", "J", "P", "#"]} // OTERO
            // letras={["A", "B", "C", "D", "P", "#"]} // OTROS
            onConfirm={manejarConfirmacionTeclado}
            title="Ingrese ubicación o código"
          />
        </Suspense>
      )}

      {modalVisible?.status && (
        <Suspense fallback={null}>
          <ModalTecladoCantidad
            darkMode={darkMode}
            modalVisible={modalVisible}
            setModalVisible={setModalVisible}
            onConfirm={handleConfirmModal}
          />
        </Suspense>
      )}

      {modalLongPressVisible.status && (
        <Suspense fallback={null}>
          <ModalLongPressPalet
            open={modalLongPressVisible.status}
            onCancel={() => setModalLongPressVisible({ status: false })}
            payload={modalLongPressVisible.payload}
            ordenActual={orden}
            setOrdenActual={setOrden}
            idUbicacionSeleccionada={idUbicacionSeleccionada}
          />
        </Suspense>
      )}

      <ModalLoteVtoVLX
        open={modalLoteVtoVLX.open}
        items={modalLoteVtoVLX.items}
        onSelect={confirmarLoteVtoVLX}
        onClose={() =>
          setModalLoteVtoVLX({
            open: false,
            items: [],
            ubicacionActual: null,
            sku: null,
          })
        }
      />
    </AppLayout>
  );
};

export default DetalleOrden;
